import React, { useState, useEffect } from "react";
import FilterFromKHStyles from "../../../revampComponents/Atom/Filters/FilterFromKHStyles";
import { filterTaskByStatus } from "./TaskManagementConstant";
import { getTaskAnalytics } from "../../../revampCRUD/taskManagement.crud";

const TaskAnalyticsFilter = ({
    analyticsData,
    setFilteredAnalyticsData,
    isRightAlign,
    setTotalCount,
    setDisplaySelectedFilters,
    selectedFilters,
    setSelectedFilters,
    statusDataName,
    setStatusDataName,
    data,
    handleFilterApply,
    taskId = null,
    limit = 50,
    offset = 0,
    search = "",
    setIsRemoveFilterClicked,
    isRemoveFilterClicked
}) => {

    const filtersConfig = [
        {
            id: "status",
            title: "Status",
            options: Object.entries(filterTaskByStatus).map(([key, value]) => ({
                value: value.toString(),
                label: key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()
            }))
        }
    ];

    const applyFilters = async () => {
        let filteredData = [...data];
        if (taskId) {
            const statusFilter = selectedFilters["status"] || [];

            const res = await getTaskAnalytics(taskId, limit, offset, search, statusFilter);
            const analyticsData = res.data?.exhibitors || [];

            setFilteredAnalyticsData(analyticsData);
            setTotalCount(analyticsData.length);
        } else {


            if (selectedFilters["status"] && selectedFilters["status"].length > 0) {
                const selectedStatus = selectedFilters["status"].map(status => parseInt(status));
                filteredData = filteredData.filter(item => selectedStatus.includes(item.task_status));
            }

            setFilteredAnalyticsData(filteredData);
            setTotalCount(filteredData.length);
        };
    }

    const handleApply = () => {
        setDisplaySelectedFilters(true);
        applyFilters();
    };

    const handleFilterChange = (filterId, selectedValues) => {
        setSelectedFilters(prev => ({
            ...prev,
            [filterId]: selectedValues
        }));
    };

    const handleClear = () => {
        setSelectedFilters({});
    };

    const cancelClickHandler = () => {
        setSelectedFilters({});
    };
    useEffect(() => {
        setSelectedFilters(selectedFilters);
        setStatusDataName(filtersConfig);
    }, [selectedFilters]);
    useEffect(() => {
        if (isRemoveFilterClicked) {
            applyFilters();
            setIsRemoveFilterClicked(false);
        }
    }, [isRemoveFilterClicked]);

    return (
        <div className={isRightAlign ? "task-analytics-filter-container" : "task-analytics-filter-component task-analytics-filter-container"}>
            <div className="filter-container analytics-filter">
                <FilterFromKHStyles
                    filtersConfig={filtersConfig}
                    selectedFilters={selectedFilters}
                    onChange={handleFilterChange}
                    onClear={handleClear}
                    onApply={handleApply}
                    cancelClickHandler={cancelClickHandler}
                    view="mobile"
                />
            </div>
            <style jsx>
                {`
.task-analytics-filter-component .filters-panel {
     display: flex;
     margin-right: 0;
     margin-left: auto;
     left: auto;
     right: 0;
}
 .task-analytics-filter-container .filter-option span {
     padding: 4px 10px;
     border-radius: 2px;
     font-weight: 500;
     font-size: 12px;
     margin-left: 7px;
}
 .task-analytics-filter-container .filter-option:nth-child(1) span {
     background-color: #f8ddcb;
     color: #fc6500;
}
 .task-analytics-filter-container .filter-option:nth-child(2) span {
     background-color: #ebf3ff;
     color: #002e6e;
}
 .task-analytics-filter-container .filter-option:nth-child(3) span {
     background-color: #23a738;
     color: #cbffd3;
}
 .task-analytics-filter-container .filter-option:nth-child(4) span {
     background-color: #cbffd3;
     color: #23a738;
}
 .task-analytics-filter-container .filter-option:nth-child(5) span {
     background-color: #dc3545;
     color: #fff;
}
 .task-analytics-filter-container .filter-option:nth-child(6) span {
     background-color: #ffdbdf;
     color: #dc3545;
}
                `}
            </style>
        </div>
    );
};

export default TaskAnalyticsFilter;